const React = require('react')
const PropTypes = require('prop-types')
const getActiveImage = require('module/user/helpers/get_active_image')
const getDisplayImage = require('module/user/helpers/get_display_image')
const getFallbackImage = require('module/user/helpers/get_fallback_image')
const DetectMobile = require('lib/detect_mobile')
const { getCloudflareUrl, getImageHighlightPosition } = require('@aboutdotme/image-helpers')
const Raven = require('lib/raven')
const log = require('log').create('large image') // eslint-disable-line
const config = require('lib/config')

class LargeImage extends React.Component {
    getStyle() {
        const { user, width } = this.props
        const { USER_AGENT } = this.context.globals
        const mobile = DetectMobile.isMobile(USER_AGENT)

        let url
        let position

        const has_image = getActiveImage(user)
        const image = getDisplayImage(user)
        const fallback = getFallbackImage()
        const desired_width = mobile ? 640 : 1200

        // determine aspect ratio
        let aspect = image.width / image.height

        // bounds check
        aspect = Math.min(3, aspect) // no wider than 3x1
        aspect = Math.max(0.6667, aspect) // no taller than 2x3

        // invert aspect and multiply by 100 to determing padding-bottom
        const paddingBottom = (1 / aspect) * 100

        if (has_image) {
            try {
                // get imgix URL
                url = getCloudflareUrl(image, {
                    width: desired_width,
                    height: desired_width / aspect,
                    quality: 40,
                    devicePixelRatio: 2,
                    crop: false,
                    image_domain: config.get('pumpkinhead.globals.aws_images'),
                })

                // get position percentages { left: 50, top: 50 }
                position = getImageHighlightPosition(image)

                // convert to CSS string '50% 50%'
                position = Object.keys(position)
                    .map((key) => {
                        return `${position[key]}%`
                    })
                    .join(' ')
            } catch (e) {
                Raven.captureException(e, {
                    extra: {
                        user_name: user.user_name,
                        image,
                    },
                })
                url = fallback.url
                position = 'center center'
            }
        } else {
            // user has no image, use the fallback url and position
            url = fallback.url
            position = 'center center'
        }

        const style = {
            backgroundImage: `url(${url})`,
            backgroundSize: 'cover',
            backgroundPosition: position,
            backgroundRepeat: 'no-repeat',
            paddingBottom: `${paddingBottom}%`,
            width,
        }

        return style
    }

    render() {
        const style = this.getStyle()

        return <div className="image" style={style}></div>
    }
}

LargeImage.propTypes = {
    user: PropTypes.shape({
        images: PropTypes.array,
        user_name: PropTypes.string,
    }).isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

LargeImage.contextTypes = {
    globals: PropTypes.object.isRequired,
}

module.exports = LargeImage
